const SubmitForm = ({
    isSubmitting,
    setIsOpen,
    disableFlag,
    setModalOpen,
}: {
    isSubmitting: boolean;
    setIsOpen: (value: boolean) => void;
    disableFlag: boolean;
    setModalOpen: any;
}) => {
    return (
        <>
            <div className='mb-[30px] flex gap-[16px]'>
                <button
                    type='button'
                    className='mt-[30px] grow rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                    onClick={() => setIsOpen(false)}
                >
                    Cancel
                </button>
                <button
                    onClick={() => setModalOpen(true)}
                    type='button'
                    className='mt-[30px] grow rounded-full border-[2px] border-[#F02D3A] bg-[#F02D3A] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-white transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                    disabled={isSubmitting || disableFlag}
                >
                    Flag
                </button>
                <button
                    type='submit'
                    className='mt-[30px] grow rounded-full border-[2px] border-[#FEBF3E] bg-[#FEBF3E] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <span className='flex items-center justify-center'>
                            <svg
                                className='mr-3 h-5 w-5 animate-spin'
                                viewBox='0 0 24 24'
                            >
                                <circle
                                    className='opacity-25'
                                    cx='12'
                                    cy='12'
                                    r='10'
                                    stroke='currentColor'
                                    strokeWidth='4'
                                />
                                <path
                                    className='opacity-75'
                                    fill='currentColor'
                                    d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                                />
                            </svg>
                            Saving...
                        </span>
                    ) : (
                        'Save'
                    )}
                </button>
            </div>
        </>
    );
};

export default SubmitForm;
